import { ParticipationFormat } from '@/shared/lib/types';
import { tp } from '@/shared/lib/typograf';
import { Tooltip } from '../TooltipV2';

type Props = {
    formats: ParticipationFormat[];
};

const ParticipationFormatsCircles = ({ formats }: Props) => {
    return (
        <ul className="participation-formats-circles">
            {formats.map((f) => {
                return (
                    <li
                        key={f.id}
                        className="participation-formats-circles__item"
                        style={{ '--color': f.color } as React.CSSProperties}
                    >
                        <Tooltip
                            content={f.description ? tp(f.description) : tp(f.name)}
                            position="bottom-right"
                            className="participation-formats-circles__desc text-xs"
                        >
                            <div className="participation-formats-circles__circle">
                                {f.caption && (
                                    <span className="participation-formats-circles__caption">{tp(f.caption)}</span>
                                )}
                            </div>
                        </Tooltip>
                        <div className="participation-formats-circles__name text-s">{tp(f.name)}</div>
                    </li>
                );
            })}
        </ul>
    );
};

export default ParticipationFormatsCircles;
